import { AUTH_CREDENTIALS_NAME } from "../Constantes";
import { login } from "../services/logeoServices";
import { getPermisosUsuario, obtenerUsuarioProfile, obtenerUsuarioByIdUsuario } from "../services/serviceUsuarios";
const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
  permisos: [],
  profile: {}
};

const POST_LOGIN_INT = "POST_LOGIN_INT";
const POST_LOGIN_OUT = "POST_LOGIN_OUT";
const GET_LOGIN_PERMISOS = "GET_LOGIN_PERMISOS";
const GET_LOGIN_PROFILE = "GET_LOGIN_PROFILE";
const CLEAR_STATE = "CLEAR_STATE";

export default function logeoReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_LOGIN_PROFILE:
      return {...state, profile: action.payload.profile}
    case GET_LOGIN_PERMISOS:
      return { ...state, permisos: action.payload.permisos }
    case POST_LOGIN_INT:
      return { ...state, exito: action.payload.exito };
    case CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
        objeto: action.payload.objeto,
      };
    default:
      return state;
  }
}

export const LogeoIntAction = (payload) => async (dispatch) => {
  return await login({payload}).then(Response => {
    localStorage.setItem(AUTH_CREDENTIALS_NAME,  Response.Token);
    dispatch({
      type: POST_LOGIN_INT,
      payload: {
        exito: 1,
      },
    });
    return Response
  }).catch(Error => {
    return Error
  })
};

export const LogeoOutAction = () => async (dispatch) => {
  localStorage.removeItem(AUTH_CREDENTIALS_NAME);
  dispatch({
    type: POST_LOGIN_OUT,
    payload: {
      exito: 1,
    },
  });
  return { status: 200 };
};
export const getPermisosCuenta = () => async (dispatch) => {
  return await getPermisosUsuario().then(Resposne => {
    dispatch({
      type: GET_LOGIN_PERMISOS,
      payload: {
        permisos: Resposne
      }
    })
  })
}
export const getProfileAction = () => async (dispatch) => {
  return await obtenerUsuarioProfile().then(Response => {
    if (Response?.UserId) {
      obtenerUsuarioByIdUsuario({IdUsuario: Response.UserId}).then(ResponseProfile => {
        dispatch({
          type: GET_LOGIN_PROFILE,
          payload: {
            profile: ResponseProfile
          }
        })
      })
    }
    return Response
  })
}
export const clearState = () => async (dispatch) => {
  dispatch({
    type: CLEAR_STATE,
    payload: {
      array: [],
      exito: 0,
      objeto: {},
    },
  });
};
